import {Feedback} from "./types"; 
// @ts-ignore
import template from './Admin.html';

export default {
    template: template,
    props: ['pages_list', 'zine_id', 'image_width'],
    data() {
        return {
            pages: [],
            feedback_by_page: {},
            people: {},
            loaded: false,
            show_checked: false,
            show_icons: false,
            show_heart_lightbulb: true,
            filter_date: new Date().toISOString().split('T')[0], // Today's date in YYYY-MM-DD format
            use_date_filter: false,
        }
    },

    async mounted() {
        this.loadSettingsFromHash();
        window.addEventListener('hashchange', this.loadSettingsFromHash);
        this.load();
    },

    watch: {
        show_checked() {
            this.updateHash();
        },
        show_heart_lightbulb() {
            this.updateHash();
        },
        use_date_filter() {
            this.updateHash();
        },
        filter_date() {
            this.updateHash();
        }
    },

    methods: {
        async load() {
            console.log('loading');
            this.feedback_by_page = {};
            // @ts-ignore
            this.pages = await (await fetch("/api/zine_version?zine_id=" + this.zine_id)).json();
            // @ts-ignore
            const response = await (await fetch("/api/all?zine_id=" + this.zine_id)).json();
            for (const feedback of response.feedbacks) {
                this.addFeedback(feedback);
            }
            // @ts-ignore
            this.people = response.people;
            this.loaded = true;
        },

        scrollToPage(pageId: string) {
          const element = document.getElementById(pageId);
          console.log("scrollToPage", pageId, element);
          if (element) {
            element.scrollIntoView();
            window.scrollBy(0, -150);
          }
        },
        
        loadSettingsFromHash() {
            const hash = window.location.hash;
            if (!hash) return;
            
            // Remove the leading # if present
            const queryString = hash.startsWith('#') ? hash.slice(1) : hash;
            const pairs = queryString.split('&');
            
            for (const pair of pairs) {
                if (!pair) continue;
                const [key, value] = pair.split('=').map(decodeURIComponent);
                
                if (key === 'show_checked') {
                    this.show_checked = value === 'true';
                } else if (key === 'show_heart_lightbulb') {
                    this.show_heart_lightbulb = value === 'true';
                } else if (key === 'filter_date') {
                    this.filter_date = value;
                    this.use_date_filter = true;
                }
            }
        },
        
        updateHash() {
            const parts = []
            if (this.show_checked) {
                parts.push(`show_checked=true`);
            }
            if (!this.show_heart_lightbulb) {
                parts.push(`show_heart_lightbulb=false`);
            }
            // Only include date filter settings if enabled
            if (this.use_date_filter) {
                parts.push(`filter_date=${encodeURIComponent(this.filter_date)}`);
            }
            history.pushState(null, '', '#' + parts.join('&'));
        },
        
        person(feedback: Feedback): Person {
            return this.people[feedback.person_id] || {}
        },
        
        addFeedback(feedback: Feedback, addToStart = false) {
            const page = feedback.zine_page;
            if (!this.feedback_by_page[page]) {
                this.feedback_by_page[page] = [];
            }
            if (addToStart) {
                this.feedback_by_page[page].unshift(feedback);
            } else {
                this.feedback_by_page[page].push(feedback);
            }
        },
    },
}
